import React from "react";
import styles2 from "./portfolioAnalysisTableCompare.module.scss";
import colorsStore from "shared/store/colorsStore";
import { useTranslation } from "react-i18next";
import { formatItalianNumber } from "utils/formatUtils";

type PortfolioAnalysisTableCompareProps = {
  data: any;
  title: string;
};
const PortfolioAnalysisTableCompare: React.FC<
  PortfolioAnalysisTableCompareProps
> = ({ data, title }) => {
  const { t } = useTranslation();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  return (
    <div className={styles2.portfolioAnalysisTable}>
      <table className={styles2.analysisTable}>
        <thead>
          <tr>
            <th>{title}</th>
            {data.map(({ year }) => (
              <th key={year} className={styles2.rightTh}>
                {year}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("portfolio.rendimentoAttesoDiPortafoglio")}</td>
            {data.map(({ year, avg_return }) => (
              <td
                key={year}
                className={styles2.rightTd}
                style={{
                  color:
                    avg_return > 0
                      ? colorsConfig.FinecoBlack
                      : colorsConfig.red,
                }}
              >
                {formatItalianNumber(avg_return)}
              </td>
            ))}
          </tr>
          <tr>
            <td
            // className="p-4 text-left font-medium"
            // style={{ color: colorsConfig.finecoBlack }}
            >
              {t("portfolio.maxPerditaPotenziale")}
            </td>
            {data.map(({ year, lower_bound }) => (
              <td
                key={year}
                className={styles2.rightTd}
                style={{
                  color:
                    lower_bound > 0
                      ? colorsConfig.FinecoBlack
                      : colorsConfig.red,
                }}
              >
                {formatItalianNumber(lower_bound)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PortfolioAnalysisTableCompare;
